/* todo move in this store all the things relative to the market view that i wrote in the odds module store.js */

import axios from 'axios'

const state = {
  spread_active_preview_prematch: [],
  spreads_list_preview_prematch: [],
  generalSpreadActivePreviewPrematch: [],
  spreadsListTopMatchPreviewPrematch: [],
  spreadActiveTopMatchPreviewPrematch: [],
  generalSpreadActiveTopMatchPreviewPrematch: [],
  spreadsListEventsDayPreviewPrematch: [],
  spreadActiveEventsDayPreviewPrematch: [],
  generalSpreadActiveEventsDayPreviewPrematch: [],
  spreadsListNextEvent: [],
  spread_active_next_events: [],
  generalSpreadActiveNextEvents: [],
  showMoreMarketsPreview: [],
  previewMarketsEnabledForMobile: [],
  marketsMapSizeButtonsDetailPrematch: [],
  marketsMapSizeButtonsDetailLive: [],
  previewTournamentVisitedExpiryTimeTTL: 3600000,
  marketGroupsActiveForTournaments: [],
  marketOrderForEventDetail: [],
  mobileMarketOrderForEventDetail: [],
  marketOrderForEventDetailLive: [],
  mobileMarketOrderForEventDetailLive: [],
  availablePagesForNextEvents: 0,
  sportsAvailableInNext3Hours: [], // todo actually need to be renamed to sportsAvailableInNext24Hours
}

const getters = {
  getSpreadActivePreviewPrematch(state) {
    return state.spread_active_preview_prematch
  },
  getSpreadsListPreviewPrematch(state) {
    return state.spreads_list_preview_prematch
  },
  getGeneralSpreadActivePreviewPrematch(state) {
    return state.generalSpreadActivePreviewPrematch
  },
  getSpreadsListTopMatchPreviewPrematch: state => {
    return state.spreadsListTopMatchPreviewPrematch
  },
  getSpreadActiveTopMatchPreviewPrematch: state => {
    return state.spreadActiveTopMatchPreviewPrematch
  },
  getGeneralSpreadActiveTopMatchPreviewPrematch: state => {
    return state.generalSpreadActiveTopMatchPreviewPrematch
  },
  getSpreadsListEventsDayPreviewPrematch: state => {
    return state.spreadsListEventsDayPreviewPrematch
  },
  getSpreadActiveEventsDayPreviewPrematch: state => {
    return state.spreadActiveEventsDayPreviewPrematch
  },
  getGeneralSpreadActiveEventsDayPreviewPrematch: state => {
    return state.generalSpreadActiveEventsDayPreviewPrematch
  },
  getShowMoreMarketsPreview: state => {
    return state.showMoreMarketsPreview
  },
  getPreviewMarketsEnabledForMobile: state => {
    return state.previewMarketsEnabledForMobile
  },
  getSpreadListsNextEvents: state => {
    return state.spreadsListNextEvent
  },
  getSpreadsActiveNextEvents: state => {
    return state.spread_active_next_events
  },
  getGeneralSpreadActivesForNextEvents: state => {
    return state.generalSpreadActiveNextEvents
  },
  getMarketsMapSizeButtonsDetailPrematch: state => {
    return state.marketsMapSizeButtonsDetailPrematch
  },
  getMarketsMapSizeButtonsDetailLive: state => {
    return state.marketsMapSizeButtonsDetailLive
  },
  getPreviewTournamentVisitedExpiryTimeTTL: state => {
    return state.previewTournamentVisitedExpiryTimeTTL
  },
  getMarketGroupsActiveForTournaments: state => {
    return state.marketGroupsActiveForTournaments
  },
  getMarketOrderForEventDetail: state => {
    return state.marketOrderForEventDetail
  },
  getMobileMarketOrderForEventDetail: state => {
    return state.mobileMarketOrderForEventDetail
  },
  getMarketOrderForEventDetailLive: state => {
    return state.marketOrderForEventDetailLive
  },
  getMobileMarketOrderForEventDetailLive: state => {
    return state.mobileMarketOrderForEventDetailLive
  },
  getAvailablePagesForNextEvents: state => {
    return state.availablePagesForNextEvents
  },
  getSportsAvailableInNext3Hours: state => {
    return state.sportsAvailableInNext3Hours // todo actually need to be renamed to sportsAvailableInNext24Hours
  },
}

const actions = {
  async updateSpreadSelectedForThisMarketOfEventPreviewPrematch(
    context,
    payload
  ) {
    context.commit(
      'UPDATE_SPREAD_SELECTED_FOR_MARKET_OF_THIS_EVENT_PREVIEW_PREMATCH',
      payload
    )
  },
  async removeSpreadSelectedForThisTournamentPreviewPrematch(context, payload) {
    context.commit(
      'DELETE_SPREAD_SELECTED_FOR_THIS_TOURNAMENT_PREVIEW_PREMATCH',
      payload
    )
  },
  async updateSpreadsListPreviewPrematchForThisTournament(context, payload) {
    context.commit(
      'UPDATE_SPREADS_LIST_PREVIEW_PREMATCH_FOR_THIS_TOURNAMENT',
      payload
    )
  },
  async updateSpreadSelectedForThisMarketOfEventTopMatchPreviewPrematch(
    context,
    payload
  ) {
    context.commit(
      'UPDATE_SPREAD_SELECTED_FOR_MARKET_OF_THIS_EVENT_TOP_GAMES_PREVIEW_PREMATCH',
      payload
    )
  },
  async updateSpreadsListTopGamesPreviewPrematchForThisTournament(
    context,
    payload
  ) {
    context.commit(
      'UPDATE_SPREADS_LIST_TOP_GAMES_PREVIEW_PREMATCH_FOR_THIS_TOURNAMENT',
      payload
    )
  },
  async updateSpreadSelectedForThisMarketOfEventOfDayPreviewPrematch(
    context,
    payload
  ) {
    context.commit(
      'UPDATE_SPREAD_SELECTED_FOR_MARKET_OF_THIS_EVENT_EVENT_OF_DAY_PREVIEW_PREMATCH',
      payload
    )
  },
  async updateSpreadsListForEventsOfDayPreviewPrematch(context, payload) {
    context.commit(
      'UPDATE_SPREADS_LIST_EVENT_OF_DAY_PREVIEW_PREMATCH_FOR_THIS_TOURNAMENT',
      payload
    )
  },
  async updateSpreadsListForNextEvents(context, payload) {
    context.commit('UPDATE_SPREADS_LIST_FOR_NEXT_EVENTS', payload)
  },
  async updateSpreadSelectedForThisMarketForThisNextEvent(context, payload) {
    context.commit(
      'UPDATE_SPREAD_SELECTED_FOR_THIS_MARKET_FOR_THIS_NEXT_EVENT',
      payload
    )
  },
  async updateSpreadsListAndSpreadSelected(context, payload) {
    if (context.rootGetters['settings/getGameConsole'] === 'marketview') {
      let headerSign = null

      switch (payload.type) {
        case 'eventsOfDay':
          if (payload.headerSign != null) {
            headerSign = payload.headerSign
          }

          if (headerSign != null) {
            headerSign = headerSign.filter(headerS => {
              return headerS.specifiersList.length > 0
            })

            for (let i = 0; i < headerSign.length; i++) {
              await context.dispatch(
                'marketview/updateSpreadsListForEventsOfDayPreviewPrematch',
                {
                  sportId: payload.sport,
                  marketId: headerSign[i].marketId,
                  spreadsList: headerSign[i].specifiersList,
                },
                { root: true }
              )

              for (let k = 0; k < payload.events.length; k++) {
                await context.dispatch(
                  'marketview/updateSpreadSelectedForThisMarketOfEventOfDayPreviewPrematch',
                  {
                    sportId: payload.sport,
                    eventId: payload.events[k].id,
                    marketId: headerSign[i].marketId,
                    spreadSelected: headerSign[i].specifiersList[0],
                  },
                  { root: true }
                )
              }
            }
          }
          break
        case 'eventsOfDayMore':
          if (payload.headerSign != null) {
            headerSign = payload.headerSign
          }

          if (headerSign != null) {
            headerSign = headerSign.filter(headerS => {
              return headerS.specifiersList.length > 0
            })

            for (let i = 0; i < headerSign.length; i++) {
              await context.dispatch(
                'marketview/updateSpreadsListForEventsOfDayPreviewPrematch',
                {
                  sportId: payload.sport,
                  marketId: headerSign[i].marketId,
                  spreadsList: headerSign[i].specifiersList,
                },
                { root: true }
              )

              const market = headerSign[i].marketId
              const generalSpreadActives =
                context.state.generalSpreadActiveEventsDayPreviewPrematch

              const generalSpreadInfo = generalSpreadActives.filter(
                thisGenerealSpread => {
                  return (
                    thisGenerealSpread.marketId == market &&
                    thisGenerealSpread.sportId == payload.sport
                  )
                }
              )

              let spreadToSelect = headerSign[i].specifiersList[0]
              if (generalSpreadInfo.length > 0) {
                spreadToSelect = generalSpreadInfo[0].spreadSelected
              }

              for (let k = 0; k < payload.events.length; k++) {
                await context.dispatch(
                  'marketview/updateSpreadSelectedForThisMarketOfEventOfDayPreviewPrematch',
                  {
                    sportId: payload.sport,
                    eventId: payload.events[k].id,
                    marketId: headerSign[i].marketId,
                    spreadSelected: spreadToSelect,
                  },
                  { root: true }
                )
              }
            }
          }
          break

        case 'eventBestPlayed':
          if (payload.headerSign != null) {
            headerSign = payload.headerSign
          }

          if (headerSign != null) {
            headerSign = headerSign.filter(headerS => {
              return headerS.specifiersList.length > 0
            })

            for (let i = 0; i < headerSign.length; i++) {
              await context.dispatch(
                'marketview/updateSpreadsListTopGamesPreviewPrematchForThisTournament',
                {
                  sportId: payload.sport,
                  marketId: headerSign[i].marketId,
                  spreadsList: headerSign[i].specifiersList,
                },
                { root: true }
              )

              const generalSpreadsActivesForBestPlayed =
                context.rootGetters[
                  'marketview/getGeneralSpreadActiveTopMatchPreviewPrematch'
                ]
              const generalSpreadActiveForThisSportMarket =
                generalSpreadsActivesForBestPlayed.find(e => {
                  return (
                    e.sportId === +payload.sport &&
                    e.marketId === +headerSign[i].marketId
                  )
                })

              let overwriteSpreadToSelect = null
              if (generalSpreadActiveForThisSportMarket != null) {
                overwriteSpreadToSelect =
                  generalSpreadActiveForThisSportMarket.spreadSelected
              }

              for (let k = 0; k < payload.events.length; k++) {
                await context.dispatch(
                  'marketview/updateSpreadSelectedForThisMarketOfEventTopMatchPreviewPrematch',
                  {
                    sportId: payload.sport,
                    eventId: payload.events[k].id,
                    marketId: headerSign[i].marketId,
                    spreadSelected:
                      overwriteSpreadToSelect != null
                        ? overwriteSpreadToSelect
                        : headerSign[i].specifiersList[0],
                  },
                  { root: true }
                )
              }
            }
          }
          break

        case 'preview':
          if (payload.headerSign != null) {
            headerSign = payload.headerSign
          }

          if (headerSign != null) {
            headerSign = headerSign.filter(headerS => {
              return headerS.specifiersList.length > 0
            })

            for (let i = 0; i < headerSign.length; i++) {
              await context.dispatch(
                'marketview/updateSpreadsListPreviewPrematchForThisTournament',
                {
                  tournamentId: payload.tournamentId,
                  marketId: headerSign[i].marketId,
                  spreadsList: headerSign[i].specifiersList,
                },
                { root: true }
              )

              for (let k = 0; k < payload.events.length; k++) {
                await context.dispatch(
                  'marketview/updateSpreadSelectedForThisMarketOfEventPreviewPrematch',
                  {
                    tournamentId: payload.tournamentId,
                    eventId: payload.events[k].id,
                    marketId: headerSign[i].marketId,
                    spreadSelected: headerSign[i].specifiersList[0],
                  },
                  { root: true }
                )
              }
            }
          }
          break

        case 'nextEvents':
          if (payload.headerSign != null) {
            headerSign = payload.headerSign
          }

          if (headerSign != null) {
            headerSign = headerSign.filter(headerS => {
              return headerS.specifiersList.length > 0
            })

            for (let i = 0; i < headerSign.length; i++) {
              await context.dispatch(
                'marketview/updateSpreadsListForNextEvents',
                {
                  sportId: payload.sport,
                  marketId: headerSign[i].marketId,
                  spreadsList: headerSign[i].specifiersList,
                },
                { root: true }
              )

              for (let k = 0; k < payload.events.length; k++) {
                const sportId = payload.sport
                const marketId = headerSign[i].marketId

                //check if i have a spread general selected for this sport/market association

                const generalSpreadsActivesForNextEvents =
                  context.rootGetters[
                    'marketview/getGeneralSpreadActivesForNextEvents'
                  ]
                const generalSpreadActiveForThisSportMarket =
                  generalSpreadsActivesForNextEvents.find(e => {
                    return e.sportId === +sportId && e.marketId === +marketId
                  })

                let overwriteSpreadToSelect = null
                if (generalSpreadActiveForThisSportMarket != null) {
                  overwriteSpreadToSelect =
                    generalSpreadActiveForThisSportMarket.spreadSelected
                }

                await context.dispatch(
                  'marketview/updateSpreadSelectedForThisMarketForThisNextEvent',
                  {
                    sportId: payload.sport,
                    eventId: payload.events[k].id,
                    marketId: headerSign[i].marketId,
                    spreadSelected:
                      overwriteSpreadToSelect != null
                        ? overwriteSpreadToSelect
                        : headerSign[i].specifiersList[0],
                  },
                  { root: true }
                )
              }
            }
          }
          break
      }
    }
  },
  async toggleShowMoreMarketsForThisTournament(context, payload) {
    context.commit(
      'TOGGLE_SHOW_MORE_MARKETS_FOR_THIS_TOURNAMENT_PREVIEW',
      payload
    )
  },
  async addPreviewMarketEnabledForMobile(context, payload) {
    context.commit('ADD_PREVIEW_MARKET_ENABLED_FOR_MOBILE', payload)
  },
  async updateMarketsMapSizeButtonsDetailPrematch(context, payload) {
    context.commit('SET_MAP_MARKET_SIZE_BUTTONS', payload)
  },
  async updateMarketsMapSizeButtonsDetailLive(context, payload) {
    context.commit('SET_MAP_MARKET_SIZE_BUTTONS_LIVE', payload)
  },

  async removePreviewMarketView(context, payload) {
    const object = payload

    await context.dispatch('odds/setMarketsGroupsIdActiveAction', [], {
      root: true,
    })
    await context.dispatch('odds/setMarketsIdActiveAction', [], { root: true })
    await context.dispatch(
      'odds/setPreviewTabSelectedForTournamentAction',
      [],
      { root: true }
    )
    context.commit('SET_SPREAD_ACTIVE_PREVIEW_PREMATCH', [])
    context.commit('SET_SPREADS_LIST_PREVIEW_PREMATCH', [])
    context.commit('SET_GENERAL_SPREAD_ACTIVE_PREVIEW_PREMATCH', [])
    await context.dispatch(
      'odds/setPreviewTabSelectedForTournamentAction',
      [],
      { root: true }
    )
  },
  updateMarketGroupActiveForTournament(context, payload) {
    context.commit('UPDATE_MARKET_GROUP_ACTIVE_FOR_TOURNAMENT', payload)
  },
  removeMarketGroupActive(context, payload) {
    context.commit('REMOVE_SINGLE_MARKET_GROUP_ACTIVE', payload)
  },
  setMarketOrderForEventDetail(context, payload) {
    context.commit('SET_MARKET_ORDER_FOR_EVENT_DETAIL', payload)
  },
  setMobileMarketOrderForEventDetail(context, payload) {
    context.commit('SET_MOBILE_MARKET_ORDER_FOR_EVENT_DETAIL', payload)
  },
  setMarketOrderForEventDetailLive(context, payload) {
    context.commit('SET_MARKET_ORDER_FOR_EVENT_DETAIL_LIVE', payload)
  },
  setMobileMarketOrderForEventDetailLive(context, payload) {
    context.commit('SET_MOBILE_MARKET_ORDER_FOR_EVENT_DETAIL_LIVE', payload)
  },
  setAvailablePagesForNextEvents(context, payload) {
    context.commit('SET_AVAILABLE_PAGES_FOR_NEXT_EVENTS', payload)
  },
  async fetchSportsAvailableInNext3Hours(context, payload) {
    const language = context.rootGetters['settings/getLanguage']

    const response = await context.dispatch(
      'treeV2/apiGetSportsTreeV2',
      {
        filter: 3,
        id_language: language,
      },
      { root: true }
    )

    if (response && response.data && response.data.sports) {
      const data = response.data.sports

      const idsToConsider = data.map(el => {
        return el.sportId
      })

      context.commit('SET_AVAILABLE_SPORTS_IN_NEXT_3HOURS', idsToConsider)
    }
  },
  async setAvailableSportsInNext3Hours(context, payload) {
    context.commit('SET_AVAILABLE_SPORTS_IN_NEXT_3HOURS', payload)
  },

  async fetchMarketByOutcomeCode(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/markets/outcomes/codes/${payload.code}/platforms/${context.rootGetters['settings/getPlatformId']}`
    return await axios.get(url, {
      headers: {
        Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
      },
    })
  },

  async apiGetMarketsBySportList(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/api/get-markets-sports-minilist-by-sportid`
    return axios.post(
      `${url}`,
      {
        sportId: payload.sportId,
        lang: context.rootGetters['settings/getLanguage'],
        excludeHugeMarkets: true,
      },
      {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      }
    )
  },
  async apiGetMarketsByPlatformSport(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/api/get-markets-sports-printodds-v2`
    return axios.post(
      `${url}`,
      {
        platformId: context.rootGetters['settings/getPlatformId'],
        sportId: payload.sportId,
        language: context.rootGetters['settings/getLanguage'],
      },
      {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      }
    )
  },
}

const mutations = {
  SET_SPREAD_ACTIVE_PREVIEW_PREMATCH(state, payload) {
    state.spread_active_preview_prematch = payload
  },

  SET_SPREADS_LIST_PREVIEW_PREMATCH(state, payload) {
    state.spreads_list_preview_prematch = payload
  },
  ADD_SPREADS_ACTIVE_INFO(state, payload) {},
  UPDATE_SPREAD_SELECTED_FOR_MARKET_OF_THIS_EVENT_PREVIEW_PREMATCH(
    state,
    payload
  ) {
    const mode = payload.mode

    const spreadInfo = {
      eventId: payload.eventId,
      marketId: payload.marketId,
      spreadSelected: payload.spreadSelected,
      tournamentId: payload.tournamentId,
    }

    const objIndex = state.spread_active_preview_prematch.findIndex(
      spreadActive =>
        spreadActive.tournamentId == payload.tournamentId &&
        spreadActive.eventId == payload.eventId &&
        spreadActive.marketId == payload.marketId
    )

    if (objIndex != -1) {
      if (mode == 'replaceExisting') {
        state.spread_active_preview_prematch[objIndex] = spreadInfo
      }
    } else {
      state.spread_active_preview_prematch.push(spreadInfo)
    }
  },

  UPDATE_SPREAD_SELECTED_FOR_MARKET_OF_THIS_TOURNAMENT_FOR_ALL_EVENTS_PREVIEW_PREMATCH(
    state,
    payload
  ) {
    const mode = payload.mode

    const spreadInfo = {
      marketId: payload.marketId,
      tournamentId: payload.tournamentId,
    }
    const spreadsActive = state.spread_active_preview_prematch

    _.forEach(spreadsActive, spreadActive => {
      if (
        spreadActive.tournamentId == payload.tournamentId &&
        spreadActive.marketId == payload.marketId
      ) {
        spreadActive.spreadSelected = payload.spreadSelected
      }
    })
    state.spread_active_preview_prematch = []
    state.spread_active_preview_prematch = spreadsActive
  },
  DELETE_SPREAD_SELECTED_FOR_THIS_TOURNAMENT_PREVIEW_PREMATCH(state, payload) {
    const filteredSpreadsInfo = state.spread_active_preview_prematch.filter(
      spreadActive => spreadActive.tournamentId != payload.tournamentId
    )
    state.spread_active_preview_prematch = filteredSpreadsInfo
  },
  UPDATE_SPREADS_LIST_PREVIEW_PREMATCH_FOR_THIS_TOURNAMENT(state, payload) {
    const mode = payload.mode

    const spreadInfo = {
      marketId: payload.marketId,
      tournamentId: payload.tournamentId,
      spreadsList: payload.spreadsList,
    }

    const objIndex = state.spreads_list_preview_prematch.findIndex(
      spreadInfo =>
        spreadInfo.tournamentId == payload.tournamentId &&
        spreadInfo.marketId == payload.marketId
    )

    if (objIndex != -1) {
      if (mode == 'replaceExisting') {
        state.spreads_list_preview_prematch[objIndex] = spreadInfo
      }
    } else {
      state.spreads_list_preview_prematch.push(spreadInfo)
    }
  },

  SET_GENERAL_SPREAD_ACTIVE_PREVIEW_PREMATCH(state, payload) {
    state.generalSpreadActivePreviewPrematch = payload
  },
  UPDATE_GENERAL_SPREAD_SELECTED_FOR_MARKET_OF_THIS_TOURNAMENT(state, payload) {
    const mode = payload.mode

    const spreadInfo = {
      tournamentId: payload.tournamentId,
      marketId: payload.marketId,
      spreadSelected: payload.spreadSelected,
    }

    const spreadsGeneralActive = state.generalSpreadActivePreviewPrematch
    const objIndex = state.generalSpreadActivePreviewPrematch.findIndex(
      spreadActive =>
        spreadActive.tournamentId == payload.tournamentId &&
        spreadActive.marketId == payload.marketId
    )

    if (objIndex != -1) {
      if (mode == 'replaceExisting') {
        state.generalSpreadActivePreviewPrematch = []
        spreadsGeneralActive[objIndex] = spreadInfo
        state.generalSpreadActivePreviewPrematch = spreadsGeneralActive
      }
    } else {
      state.generalSpreadActivePreviewPrematch.push(spreadInfo)
    }
  },
  UPDATE_GENERAL_SPREAD_SELECTED_FOR_BEST_MATCH_FOR_SPORT(state, payload) {
    let mode = null

    if (payload.mode != null) {
      mode = payload.mode
    }

    const spreadInfo = {
      sportId: payload.sportId,
      marketId: payload.marketId,
      spreadSelected: payload.spreadSelected,
    }

    const spreadsGeneralActive =
      state.generalSpreadActiveTopMatchPreviewPrematch
    const objIndex = state.generalSpreadActiveTopMatchPreviewPrematch.findIndex(
      spreadActive =>
        spreadActive.sportId == payload.sportId &&
        spreadActive.marketId == payload.marketId
    )

    if (objIndex != -1) {
      if (mode != null && mode == 'replaceExisting') {
        state.generalSpreadActiveTopMatchPreviewPrematch = []
        spreadsGeneralActive[objIndex] = spreadInfo
        state.generalSpreadActiveTopMatchPreviewPrematch = spreadsGeneralActive
      }
    } else {
      state.generalSpreadActiveTopMatchPreviewPrematch.push(spreadInfo)
    }
  },
  UPDATE_SPREAD_SELECTED_FOR_MARKET_OF_THIS_SPORT_FOR_ALL_EVENTS_TOP_GAMES_PREVIEW_PREMATCH(
    state,
    payload
  ) {
    let mode = null

    if (payload.mode != null) {
      mode = payload.mode
    }

    const spreadsActive = state.spreadActiveTopMatchPreviewPrematch

    _.forEach(spreadsActive, spreadActive => {
      if (
        spreadActive.sportId == payload.sportId &&
        spreadActive.marketId == payload.marketId
      ) {
        spreadActive.spreadSelected = payload.spreadSelected
      }
    })
    state.spreadActiveTopMatchPreviewPrematch = []
    state.spreadActiveTopMatchPreviewPrematch = spreadsActive
  },
  UPDATE_SPREAD_SELECTED_FOR_MARKET_OF_THIS_EVENT_TOP_GAMES_PREVIEW_PREMATCH(
    state,
    payload
  ) {
    let mode = null
    mode = payload.mode

    const spreadInfo = {
      eventId: payload.eventId,
      marketId: payload.marketId,
      spreadSelected: payload.spreadSelected,
      sportId: payload.sportId,
    }
    const objIndex = state.spreadActiveTopMatchPreviewPrematch.findIndex(
      spreadActive =>
        spreadActive.sportId == payload.sportId &&
        spreadActive.eventId == payload.eventId &&
        spreadActive.marketId == payload.marketId
    )

    if (objIndex != -1) {
      if (mode != null && mode == 'replaceExisting') {
        state.spreadActiveTopMatchPreviewPrematch[objIndex] = spreadInfo
      }
    } else {
      state.spreadActiveTopMatchPreviewPrematch.push(spreadInfo)
    }
  },
  UPDATE_SPREADS_LIST_TOP_GAMES_PREVIEW_PREMATCH_FOR_THIS_TOURNAMENT(
    state,
    payload
  ) {
    let mode = null

    mode = payload.mode

    const spreadInfo = {
      marketId: payload.marketId,
      sportId: payload.sportId,
      spreadsList: payload.spreadsList,
    }

    const objIndex = state.spreadsListTopMatchPreviewPrematch.findIndex(
      spreadInfo =>
        spreadInfo.sportId == payload.sportId &&
        spreadInfo.marketId == payload.marketId
    )

    if (objIndex != -1) {
      if (mode != null && mode == 'replaceExisting') {
        state.spreadsListTopMatchPreviewPrematch[objIndex] = spreadInfo
      }
    } else {
      state.spreadsListTopMatchPreviewPrematch.push(spreadInfo)
    }
  },

  UPDATE_SPREADS_LIST_FOR_NEXT_EVENTS(state, payload) {
    let mode = null

    mode = payload.mode

    const spreadInfo = {
      marketId: payload.marketId,
      sportId: payload.sportId,
      spreadsList: payload.spreadsList,
    }

    const objIndex = state.spreadsListNextEvent.findIndex(
      spreadInfo =>
        spreadInfo.sportId == payload.sportId &&
        spreadInfo.marketId == payload.marketId
    )

    if (objIndex != -1) {
      if (mode != null && mode == 'replaceExisting') {
        state.spreadsListNextEvent[objIndex] = spreadInfo
      }
    } else {
      state.spreadsListNextEvent.push(spreadInfo)
    }
  },

  UPDATE_SPREAD_SELECTED_FOR_THIS_MARKET_FOR_THIS_NEXT_EVENT(state, payload) {
    const mode = payload.mode != null ? payload.mode : 'normal'

    const spreadInfo = {
      eventId: payload.eventId,
      marketId: payload.marketId,
      spreadSelected: payload.spreadSelected,
      sportId: payload.sportId,
    }

    const objIndex = state.spread_active_next_events.findIndex(
      spreadActive =>
        spreadActive.sportId == payload.sportId &&
        spreadActive.eventId == payload.eventId &&
        spreadActive.marketId == payload.marketId
    )

    if (objIndex != -1) {
      if (mode == 'replaceExisting') {
        state.spread_active_next_events[objIndex] = spreadInfo
      }
    } else {
      state.spread_active_next_events.push(spreadInfo)
    }
  },

  UPDATE_SPREAD_SELECTED_FOR_MARKET_OF_THIS_EVENT_EVENT_OF_DAY_PREVIEW_PREMATCH(
    state,
    payload
  ) {
    let mode = null
    mode = payload.mode

    const spreadInfo = {
      eventId: payload.eventId,
      marketId: payload.marketId,
      spreadSelected: payload.spreadSelected,
      sportId: payload.sportId,
    }
    const objIndex = state.spreadActiveEventsDayPreviewPrematch.findIndex(
      spreadActive =>
        spreadActive.sportId == payload.sportId &&
        spreadActive.eventId == payload.eventId &&
        spreadActive.marketId == payload.marketId
    )

    if (objIndex != -1) {
      if (mode != null && mode == 'replaceExisting') {
        state.spreadActiveEventsDayPreviewPrematch[objIndex] = spreadInfo
      }
    } else {
      state.spreadActiveEventsDayPreviewPrematch.push(spreadInfo)
    }
  },
  UPDATE_SPREADS_LIST_EVENT_OF_DAY_PREVIEW_PREMATCH_FOR_THIS_TOURNAMENT(
    state,
    payload
  ) {
    let mode = null
    mode = payload.mode

    const spreadInfo = {
      marketId: payload.marketId,
      sportId: payload.sportId,
      spreadsList: payload.spreadsList,
    }

    const objIndex = state.spreadsListEventsDayPreviewPrematch.findIndex(
      spreadInfo =>
        spreadInfo.sportId == payload.sportId &&
        spreadInfo.marketId == payload.marketId
    )

    if (objIndex != -1) {
      if (mode != null && mode == 'replaceExisting') {
        state.spreadsListEventsDayPreviewPrematch[objIndex] = spreadInfo
      }
    } else {
      state.spreadsListEventsDayPreviewPrematch.push(spreadInfo)
    }
  },
  UPDATE_GENERAL_SPREAD_SELECTED_FOR_EVENT_OF_DAY_FOR_SPORT(state, payload) {
    let mode = null

    if (payload.mode != null) {
      mode = payload.mode
    }

    const spreadInfo = {
      sportId: payload.sportId,
      marketId: payload.marketId,
      spreadSelected: payload.spreadSelected,
    }

    const spreadsGeneralActive =
      state.generalSpreadActiveEventsDayPreviewPrematch
    const objIndex =
      state.generalSpreadActiveEventsDayPreviewPrematch.findIndex(
        spreadActive =>
          spreadActive.sportId == payload.sportId &&
          spreadActive.marketId == payload.marketId
      )

    if (objIndex != -1) {
      if (mode != null && mode == 'replaceExisting') {
        state.generalSpreadActiveEventsDayPreviewPrematch = []
        spreadsGeneralActive[objIndex] = spreadInfo
        state.generalSpreadActiveEventsDayPreviewPrematch = spreadsGeneralActive
      }
    } else {
      state.generalSpreadActiveEventsDayPreviewPrematch.push(spreadInfo)
    }
  },
  UPDATE_SPREAD_SELECTED_FOR_MARKET_OF_THIS_SPORT_FOR_ALL_EVENTS_OF_DAY_PREVIEW_PREMATCH(
    state,
    payload
  ) {
    let mode = null

    if (payload.mode != null) {
      mode = payload.mode
    }

    const spreadsActive = state.spreadActiveEventsDayPreviewPrematch

    _.forEach(spreadsActive, spreadActive => {
      if (
        spreadActive.sportId == payload.sportId &&
        spreadActive.marketId == payload.marketId
      ) {
        spreadActive.spreadSelected = payload.spreadSelected
      }
    })
    state.spreadActiveEventsDayPreviewPrematch = []
    state.spreadActiveEventsDayPreviewPrematch = spreadsActive
  },
  TOGGLE_SHOW_MORE_MARKETS_FOR_THIS_TOURNAMENT_PREVIEW(state, payload) {
    const previewGroupMarketsShowMore = state.showMoreMarketsPreview
    const objIndex = previewGroupMarketsShowMore.findIndex(
      showMoreInfo => showMoreInfo.tournamentId == payload.tournamentId
    )

    if (objIndex != -1) {
      state.showMoreMarketsPreview = []
      previewGroupMarketsShowMore[objIndex] = {
        tournamentId: payload.tournamentId,
        showMore: !previewGroupMarketsShowMore[objIndex].showMore,
      }
      state.showMoreMarketsPreview = previewGroupMarketsShowMore
    } else {
      state.showMoreMarketsPreview.push({
        tournamentId: payload.tournamentId,
        showMore: true,
      })
    }
  },
  ADD_PREVIEW_MARKET_ENABLED_FOR_MOBILE(state, payload) {
    const objIndex = state.previewMarketsEnabledForMobile.findIndex(
      marketEnabled =>
        marketEnabled.sportId == payload.sportId &&
        marketEnabled.tournamentId == payload.tournamentId
    )

    if (objIndex == -1) {
      const objToSave = {
        sportId: payload.sportId,
        sport_id: payload.sport_id,
        tournamentId: payload.tournamentId,
        data: payload.data,
      }

      state.previewMarketsEnabledForMobile.push(objToSave)
    }
  },

  SET_PREVIEW_MARKETS_ENABLED_FOR_MOBILE(state, payload) {
    state.previewMarketsEnabledForMobile = payload
  },

  UPDATE_GENERAL_SPREAD_SELECTED_FOR_NEXT_EVENTS(state, payload) {
    let mode = null

    if (payload.mode != null) {
      mode = payload.mode
    }

    const spreadInfo = {
      sportId: payload.sportId,
      marketId: payload.marketId,
      spreadSelected: payload.spreadSelected,
    }

    const spreadsGeneralActive = state.generalSpreadActiveNextEvents
    const objIndex = state.generalSpreadActiveNextEvents.findIndex(
      spreadActive =>
        spreadActive.sportId == payload.sportId &&
        spreadActive.marketId == payload.marketId
    )

    if (objIndex != -1) {
      if (mode != null && mode == 'replaceExisting') {
        state.generalSpreadActiveNextEvents = []
        spreadsGeneralActive[objIndex] = spreadInfo
        state.generalSpreadActiveNextEvents = spreadsGeneralActive
      }
    } else {
      state.generalSpreadActiveNextEvents.push(spreadInfo)
    }
  },

  UPDATE_SPREAD_SELECTED_FOR_MARKET_FOR_ALL_EVENTS_NEXT_EVENTS(state, payload) {
    let mode = null

    if (payload.mode != null) {
      mode = payload.mode
    }

    const spreadsActive = state.spread_active_next_events

    _.forEach(spreadsActive, spreadActive => {
      if (
        spreadActive.sportId == payload.sportId &&
        spreadActive.marketId == payload.marketId
      ) {
        spreadActive.spreadSelected = payload.spreadSelected
      }
    })
    state.spread_active_next_events = []
    state.spread_active_next_events = spreadsActive
  },

  SET_MAP_MARKET_SIZE_BUTTONS(state, payload) {
    state.marketsMapSizeButtonsDetailPrematch = []
    if (payload != null && payload.length > 0) {
      state.marketsMapSizeButtonsDetailPrematch = payload
    }
  },
  SET_MAP_MARKET_SIZE_BUTTONS_LIVE(state, payload) {
    state.marketsMapSizeButtonsDetailLive = []
    if (payload != null && payload.length > 0) {
      state.marketsMapSizeButtonsDetailLive = payload
    }
  },
  UPDATE_MARKET_GROUP_ACTIVE_FOR_TOURNAMENT(state, payload) {
    const saveState = state.marketGroupsActiveForTournaments

    const find = state.marketGroupsActiveForTournaments.find(marketGroup => {
      return marketGroup.tournamentId === payload.tournamentId
    })

    if (find == null) {
      saveState.push({
        groupId: payload.groupId,
        tournamentId: payload.tournamentId,
      })
    } else {
      find.groupId = payload.groupId
      find.tournamentId = payload.tournamentId
    }

    state.marketGroupsActiveForTournaments = saveState
  },
  REMOVE_SINGLE_MARKET_GROUP_ACTIVE(state, payload) {
    state.marketGroupsActiveForTournaments =
      state.marketGroupsActiveForTournaments.filter(marketGroup => {
        return marketGroup.tournamentId !== payload.tournamentId
      })
  },
  SET_MARKET_ORDER_FOR_EVENT_DETAIL(state, payload) {
    state.marketOrderForEventDetail = payload
  },
  SET_MOBILE_MARKET_ORDER_FOR_EVENT_DETAIL(state, payload) {
    state.mobileMarketOrderForEventDetail = payload
  },
  SET_MARKET_ORDER_FOR_EVENT_DETAIL_LIVE(state, payload) {
    state.marketOrderForEventDetailLive = payload
  },
  SET_MOBILE_MARKET_ORDER_FOR_EVENT_DETAIL_LIVE(state, payload) {
    state.mobileMarketOrderForEventDetailLive = payload
  },
  SET_AVAILABLE_PAGES_FOR_NEXT_EVENTS(state, payload) {
    if (payload != null && +payload >= 0) {
      state.availablePagesForNextEvents = payload
    }
  },
  SET_AVAILABLE_SPORTS_IN_NEXT_3HOURS(state, payload) {
    state.sportsAvailableInNext3Hours = payload
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
